/**
 * ── WHERE A REQUEST CAN BE (2026-09-09) ────────────────────────────────────────
 * The one place that answers "which US states can a request for division X sit in?"
 * — used by the sole-pick resolver (useEchDyn) to refuse a namesake community from
 * another state, and by the wizard's national search to keep other divisions'
 * namesakes out of the roster. Katy, BAH, "Creekside": nine hits from three states,
 * and nothing on screen said which was hers.
 *
 * A division can span states (MDH: MD/VA/WV/DC; PEN: PA/DE; SEA: WA/ID), so the
 * answer is the SET of its markets' states, never one "division state".
 */
import { divMarkets } from "./snapshots";
import { MARKETS, MARKET_STATE } from "./requestData";

/**
 * every two-letter state the division can be in: its markets' states (MARKET_STATE)
 * plus whatever states its own refdata community rows carry — the monolith's market
 * table has code collisions (MDH's BER is Berkeley County WV, the table says SC) and
 * gaps (no DC), so the division's real rows are the ground truth and the table is
 * the floor. "" division → [] (nothing is refused).
 */
export function echDivisionStates(div: unknown, rowStates?: Iterable<unknown>): string[] {
  const dv = String(div || "").toUpperCase().trim();
  if (!dv) return [];
  /* divMarkets falls back to EVERY market for an unknown code — only trust it
     when it is the division's own list */
  const dm = divMarkets(dv);
  const own = dm.length && dm.length < MARKETS.length ? dm : [];
  const out = new Set<string>();
  if (MARKET_STATE[dv]) out.add(MARKET_STATE[dv].toUpperCase());
  own.forEach((m) => { const st = MARKET_STATE[m[0]]; if (st) out.add(String(st).toUpperCase()); });
  if (rowStates) for (const r of rowStates) { const st = String(r || "").toUpperCase().trim(); if (/^[A-Z]{2}$/.test(st)) out.add(st); }
  return Array.from(out);
}

/** true when `state` is one the request can be in; an unknown state never disqualifies */
export function echStateAllowed(state: unknown, allowed: string[]): boolean {
  const st = String(state || "").toUpperCase().trim();
  if (!st || !allowed.length) return true;
  return allowed.indexOf(st) >= 0;
}
